import React from "react";
import { Link } from "react-router-dom";
import { ExternalLink } from "lucide-react";
import FadeIn from "./FadeIn";

const OpportunityCardGrid = ({ title, subtitle, cards, testimonials }) => (
  <section className="ku-section bg-white">
    <div className="ku-container">
      <FadeIn>
        <h2 className="ku-heading-lg text-center mb-2">{title}</h2>
        {subtitle && <p className="text-center text-gray-600 font-body text-lg mb-10">{subtitle}</p>}
      </FadeIn>
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 mb-16">
        {cards.map((card, i) => (
          <FadeIn key={card.name} delay={i * 0.06}>
            <a
              href={card.href}
              target="_blank"
              rel="noopener noreferrer"
              className="group block ku-card p-6 h-full hover:border-ku-lavender/50 border-2 border-transparent transition-all"
            >
              <h3 className="font-display text-xl font-bold text-ku-royal mb-2 group-hover:text-ku-violet transition-colors">
                {card.name}
              </h3>
              <p className="font-body text-gray-600 text-sm leading-relaxed mb-4">{card.description}</p>
              <span className="inline-flex items-center gap-2 font-accent text-sm font-semibold text-ku-violet">
                Apply <ExternalLink className="w-4 h-4" />
              </span>
            </a>
          </FadeIn>
        ))}
      </div>
      {testimonials?.length > 0 && (
        <>
          <FadeIn>
            <h3 className="font-display text-2xl font-bold text-ku-royal text-center mb-8">Testimonals</h3>
          </FadeIn>
          <div className="grid md:grid-cols-2 gap-6">
            {testimonials.map((t, i) => (
              <FadeIn key={t.name} delay={i * 0.08}>
                <div className="ku-glass rounded-ku-lg p-6">
                  <p className="font-body text-gray-700 italic mb-6">&ldquo;{t.quote}&rdquo;</p>
                  <div className="flex items-center gap-4">
                    <img src={t.image} alt={t.name} className="w-14 h-14 rounded-full object-cover ring-2 ring-ku-soft" />
                    <div>
                      <p className="font-display font-semibold text-ku-royal">{t.name}</p>
                      {t.role && <p className="text-sm text-gray-500">{t.role}</p>}
                    </div>
                  </div>
                </div>
              </FadeIn>
            ))}
          </div>
        </>
      )}
    </div>
  </section>
);

export default OpportunityCardGrid;
